/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Col_SkuInputs */

const vi_warehouse_sales_col_sku = /** @type {(inputs: Warehouse_Sales_Col_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã SP`)
};

/**

* @param {Warehouse_Sales_Col_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_col_sku = /** @type {((inputs?: Warehouse_Sales_Col_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Col_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_col_sku(inputs)
});